import { css } from "@compiled/react";

import { media } from "@atlaskit/primitives";

import { wacToken } from "@/libraries/design/foundations";
import { checkFeatureFlagGate, featureFlags } from "@/utils/feature-flags";

import { MAX_SELECTABLE, checkboxValues } from "../constants";

import JtbdCheckbox from "./jtbdCheckbox";

const headerStyles = css({
    fontFamily: wacToken("font.charlie.display"),
    fontWeight: 700,
    color: wacToken("color.primary.black"),
    fontSize: "1.25rem",
    lineHeight: "1.75rem",
    margin: "10px 0 24px",
    textAlign: "center"
});

const headerVisualUpdateStyles = css({
    fontFamily: "var(--atlassian-sans-font-family)"
});

const gridWrapperStyle = css({
    display: "grid",
    margin: "0 auto",
    border: "none",
    gap: "1.5rem",
    maxWidth: "850px",
    gridTemplateColumns: "repeat(2, 1fr)",
    [media.below.sm]: {
        gridTemplateColumns: "none"
    }
});

const CheckboxGrid = ({
    checkboxes,
    handleCheckboxChange,
    header,
    // errorState,
    // handleErrorChange,
    numSelected,
    disableSelectionLimit = false
}: {
    checkboxes: checkboxValues[];
    handleCheckboxChange: (checkboxes: checkboxValues[]) => void;
    header?: string;
    // errorState: { display: boolean; message: string };
    // handleErrorChange: (display: boolean, message: string) => void;
    numSelected: number;
    disableSelectionLimit?: boolean;
}) => {
    const modalVisualUpdates = checkFeatureFlagGate(
        featureFlags.cfind4831ProductOverlayModalVisualUpdates
    );

    const handleClick = (i: number) => {
        const newCheckboxArr = [...checkboxes];
        if (i >= 0 && i < checkboxes.length) {
            const updatedObject: checkboxValues = {
                ...checkboxes[i]
            } as checkboxValues;
            updatedObject.isChecked = !updatedObject.isChecked;
            newCheckboxArr[i] = updatedObject;
            if (
                (updatedObject.isChecked &&
                    (disableSelectionLimit || numSelected < MAX_SELECTABLE)) ||
                !updatedObject.isChecked
            ) {
                // handleErrorChange(false, "");
                handleCheckboxChange(newCheckboxArr);
            } else {
                // TODO if need to set error message
                // handleErrorChange(true, "Max of 3 selection");
            }
        }
    };

    return (
        <>
            {!disableSelectionLimit && header && (
                <h5
                    css={[
                        headerStyles,
                        modalVisualUpdates && headerVisualUpdateStyles
                    ]}
                >
                    {header}
                </h5>
            )}
            {/* <div style={{ height: "30px" }}>
                {errorState.display && (
                    <div>
                        <label style={{ color: "red" }}>
                            {errorState.message}
                        </label>
                    </div>
                )}
            </div> */}
            <div css={gridWrapperStyle}>
                {checkboxes.map((checkbox, i) => {
                    return (
                        <JtbdCheckbox
                            key={checkbox.name}
                            name={checkbox.name}
                            id={checkbox.id}
                            isChecked={checkbox.isChecked}
                            handleClick={() => {
                                handleClick(i);
                            }}
                            isDisabled={
                                !disableSelectionLimit &&
                                numSelected === MAX_SELECTABLE &&
                                !checkbox.isChecked
                            }
                        />
                    );
                })}
            </div>
        </>
    );
};

export default CheckboxGrid;
